import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class RegisteredEntityMetaDataService {
  abstract registeredEntityNames$: Observable<string[]>;
}
